/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import "../../virtualShop.css";
import { Icon, Row, Col, Button, Modal, Input, Form, message, Select, Checkbox, Tooltip } from "antd";
import TableIDs from '../../data/TableIDs.js';
import GoogleAddress from "./GoogleAddress";
import modal_logo from "../../skins/index/modal_logo.png";
import moment from "moment";
import ResponsiveTable from "../../components/ResponsiveTable.js";
import GenericModal from "../../components/GenericModal.js";
import MultiPolygonMap from "../../components/MultiPolygonMap.js";

const { Option } = Select;

class DeliveryTypeFields extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            addressError: false,
            modalNotOpen: false,
            modalNotAreaFind: null,
            // addressValue: null,
        }

        this.mobile = window.innerWidth <= 700 ? true : false;

        this.id = "FOOD_FORMAT_ORDER_FIELDS";
        this.dQtn_id = "DELIVERY_QTN_TABLE";
        this.setting_id = "FORMAT_SITE_SETTINGS";
        this.branches_id = "BRANCHES_LIST";
        this.times_id = "BRANCHES_TIMES";
        this.areas_id = "BRANCH_SHIPPING_AREAS";
        this.areasAll_id = "BRANCH_SHIPPING_AREAS_ALL";

        if (props.data[this.id] === undefined) props.data[this.id] = { orderType: '0', orderFields: {} };
        if (props.data[this.dQtn_id] === undefined) props.data[this.dQtn_id] = { data: [] };
        if (props.data[this.setting_id] === undefined) props.data[this.setting_id] = {};
        if (props.data[this.branches_id] === undefined) props.data[this.branches_id] = { dataset: [] };
        if (props.data[this.times_id] === undefined) props.data[this.times_id] = { dataset: [], hours: [] };
        if (props.data[this.areas_id] === undefined) props.data[this.areas_id] = { dataset: [] };
        if (props.data[this.areasAll_id] === undefined) props.data[this.areasAll_id] = { dataset: [] };

        if (props.data[TableIDs.genericSelectorDeliveryMethods] === undefined) props.data[TableIDs.genericSelectorDeliveryMethods] = { dataset: [] };

        this.api = {
            get_settings: "get_orders_site_settings",
            delivery_qtn: "delivery_qtn_table",
            get_times: "get_future_order_times",
        }

        this.sendAPI = this.props.sendAPI;
        this.getText = this.props.getText;

        this.branchChecked = null;
        this.addressCoordinates = null;



    }

    componentDidMount() {
        this.props.apiBranches();
        // let _branch = this.props.isFromPos && this.props.data[this.id].orderFields.dBranch ? this.props.data[this.id].orderFields.dBranch : 0;
        //דני ביקש לשנות 16-03-2025
        let _branch = this.props.data[this.id].orderFields.dBranch ? this.props.data[this.id].orderFields.dBranch : 0;
        this.sendAPI(this.api.get_settings, "_branch\r" + _branch, (ob3) => {
            if (ob3.data) {
                let parseData = ob3.data.split("\r");
                let keys = parseData[0] ? parseData[0].split("\f") : [];
                let values = parseData[1] ? parseData[1].split("\f") : [];
                let sObj = {};
                keys.map((x, i) => { sObj = { ...sObj, [x]: values[i] } })
                this.props.setJson(this.setting_id, sObj)
            }
        }, this.props.errorCallback);
    }


    isPointInPolygon = (lat, lng, polygonCoordsString) => {
        if (!polygonCoordsString) return false;

        // המרה ממחרוזת למערך של LatLng
        const polygonCoords = polygonCoordsString.split(", ").map(coord => {
            const [lng, lat] = coord.split(" ").map(Number);
            return { lat, lng };
        });

        let inside = false;
        let j = polygonCoords.length - 1; // נקודת הקצה של הפוליגון

        // לעבור על כל הצלעות של הפוליגון
        for (let i = 0; i < polygonCoords.length; i++) {
            const xi = polygonCoords[i].lng, yi = polygonCoords[i].lat;
            const xj = polygonCoords[j].lng, yj = polygonCoords[j].lat;

            const intersect = ((yi > lat) !== (yj > lat)) && (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;

            j = i; // move to the next vertex
        }

        return inside;
    };




    componentDidUpdate(p) {
        let ftData = this.props.modalData;
        let changeBranch = this.props.changeBranch;



        if (ftData && p.modalData !== ftData && this.props.data[this.id].orderType !== ftData) {
            // this.props.apiBranches();

            this.sendAPI(this.api.delivery_qtn, ftData, (ob) => {
                let data = []
                if (ob.data) {
                    data = ob.data.split("\r").map((x) => {
                        let y = x.split("\f");
                        let isSelect = y[2] === 'Select';
                        let options = y[4] && isSelect ? y[4].split(',') : [];
                        return {
                            mID: y[0],
                            mDesc: y[1],
                            mType: y[2],
                            mIsMandatory: y[3],
                            mOptions: options,
                            mValue: y[5],
                        }
                    })
                }
                this.props.setJson(this.dQtn_id, { data })
            }, this.props.errorCallback)

            setTimeout(() => {
                let dMethods = this.props.data[TableIDs.genericSelectorDeliveryMethods].dataset;
                const { orderFields } = this.props.data[this.id]
                let dmData = dMethods.find(f => f.code === ftData);
                let nAddress = dmData && dmData.needAddress === '1' ? true : false;
                if (nAddress && !(orderFields.dLat || orderFields.dLng)) {
                    this.props.setJson(this.id + ".orderFields", { dBranch: null })
                }
                if (!nAddress) {
                    this.props.setJson(this.id + ".orderFields", {
                        dCity: '',
                        dStreet: '',
                        dBuilding: '',
                        dLat: '',
                        dLng: '',
                        dFullAddress: ''
                    })
                }
            }, 1000);

        }


        if (changeBranch && p.changeBranch !== changeBranch) {
            setTimeout(() => {
                this.onChangeBranch(changeBranch)
            }, 500);
        }

        if (this.props.modalData && p.modalData !== this.props.modalData) {
            setTimeout(() => {
                this.onChangeBranch(this.props.data[this.id].orderFields?.dBranch, this.props.modalData)
            }, 500);
        }

        const { dAreaId, dLng, dLat } = this.props.data[this.id].orderFields ?? {}

        if (
            (this.branchChecked !== this.props.data[this.id].orderFields?.dBranch || this.addressCoordinates !== (dLng + '-' + dLat))
            && this.props.data[this.setting_id].pDeliveryCalcType == '1') {
            this.branchChecked = this.props.data[this.id].orderFields?.dBranch;
            this.addressCoordinates = dLng + '-' + dLat;
            this.props.sendAPI("get_branch_shipping_areas", '_branch\f_filterType\r' + this.props.data[this.id].orderFields?.dBranch + '\f1', (ob) => {
                let d = ob.data ? ob.data.split("\r") : [];
                let h = d[0] ? d[0].split("\f") : []
                let dataset = d.slice(1, -1).map(x => {
                    let y = x.split("\f");
                    let obj = {}
                    h.forEach((z, i) => { obj = { ...obj, [z]: y[i] } })
                    return obj
                })
                dataset = dataset.filter(f => this.isPointInPolygon(dLat, dLng, f._Poligon))
                this.props.setJson(this.areas_id, { dataset })
                if (dataset.length === 1) {
                    this.onChangeArea(dataset[0])
                } else if (!dataset.find(f => f._ID == dAreaId)) {
                    this.props.setJson(this.id + ".orderFields", { dAreaId: "", dAreaName: "", dAreaPrice: "", dAreaMinimum: "", dAreaMinutes: "" })
                }

            }, this.props.errorCallback)

            this.props.sendAPI("get_branch_shipping_areas_all", '', (ob) => {
                this.props.setJson(this.areasAll_id, {
                    dataset: ob.data ? ob.data.split("\r").map(x => {
                        const [key, description, branch, poligon] = x.split("\f")
                        return { key, description, branch, coordinates: poligon ? poligon.split(", ").map(z => z.split(" ")) : [] }
                    }) : []
                })
            }, this.props.errorCallback)

        }


    }

    labelStyle = (text, required) => {
        let siteSettings = this.props.data[this.setting_id];
        let isStyle3 = siteSettings.pDesktopCategoriesView == '3';
        return (<div className={"text_item"}>
            {required ?
                isStyle3 ?
                    (<span><span style={{ color: 'red' }}> * </span>{text}</span>)
                    : (<span style={{ color: 'red' }}>{text} *</span>)
                : text}
        </div>)
    }

    fieldSelectStyle = (key, value, onChange, content, valid, showSearch) => {
        let isStyle4 = this.props.data[this.setting_id].pDesktopCategoriesView == '4';
        let isStyle5 = this.props.data[this.setting_id].pDesktopCategoriesView == '5';
        let isStyle6 = this.props.data[this.setting_id].pDesktopCategoriesView == '6';
        let arrowIcon = isStyle4 || isStyle5 || isStyle6 ?
            (<span><div className="cotw_arrow_icon" style={{
                padding: 2,
                marginTop: -5,
                borderRadius: "50%",
                background: isStyle6 ? "#ddc268" : "#BE1E2D",
                color: isStyle6 ? "black" : "white",
                width: 24,
                height: 24,
                fontSize: 20,
                fontWeight: "bold"
            }} ><Icon type="down" /></div></span>)
            : (<span><div className={"collapse_icon_active cotw_arrow_icon"} style={{ marginTop: -5 }} /></span>);

        let classDiv = "choose_container";
        if (key === "dBranch" && !isStyle6) classDiv += "_b_selector"
        if (isStyle6) classDiv += "_type_6"

        let props = { key, value, onChange, showSearch, filterOption: showSearch, optionFilterProp: showSearch ? "valuefilter" : "" }
        if ((isStyle4 || isStyle5) && key === "dBranch") props = { ...props, style: { height: 100 } }
        // if (key === "dAreaId") props = { ...props, onFocus:  }
        const { dAreaName, dCity } = this.props.data[this.id].orderFields ?? {}
        let disabledArea = dAreaName && dAreaName.indexOf(dCity) > -1
        return (<div className={classDiv}>
            <Form.Item validateStatus={!valid ? "error" : "Success"}>
                {key === "dAreaId" ?
                    (<Input {...props} className={"text_item"} style={{ height: 50, cursor: "pointer" }} readOnly // disabled={disabledArea}
                        suffix={<span onClick={() => { if (!disabledArea) this.setState({ modalAreas: true }) }}>{arrowIcon}</span>}
                        onClick={() => { if (!disabledArea) this.setState({ modalAreas: true }) }} />)
                    : <Select {...props} suffixIcon={arrowIcon} >{content}</Select>}
            </Form.Item>
        </div>)
    }

    fieldStyle = (text, field, span) => {
        let mData = this.props.modalData;
        let oData = this.props.data[this.id];
        let dMethods = this.props.data[TableIDs.genericSelectorDeliveryMethods].dataset;
        let dmData = dMethods.find(f => f.code === mData);

        let RequiredFields = ['dName', 'dPhone', 'dBranch'];
        if (dmData && dmData.needAddress === '1') {
            RequiredFields = [...RequiredFields, 'dCity', 'dStreet', 'dBuilding'];
            if (this.props.data[this.setting_id].pDeliveryCalcType == '1') RequiredFields = [...RequiredFields, 'dAreaId'];
        }

        let isStyle4 = this.props.data[this.setting_id].pDesktopCategoriesView == '4'
        let isStyle5 = this.props.data[this.setting_id].pDesktopCategoriesView == '5'

        return (<Col style={{ paddingLeft: 10, paddingRight: 10 }} span={this.mobile || isStyle4 || isStyle5 ? 24 : span}>
            {this.labelStyle(this.getText(text), RequiredFields.indexOf(field) > -1 ? true : false)}
            {field === 'dAreaId' ?
                this.fieldSelectStyle(
                    'dAreaId',
                    oData.orderFields['dAreaName'],
                    () => { },
                    this.props.data[this.areas_id].dataset.map(x => <Option value={x._ID}>{x._Name}</Option>),
                    oData.orderFields['dAreaId'],
                    false)
                : field === 'dBranch' ?
                    this.fieldSelectStyle(
                        'dBranch',
                        oData.orderFields['dBranch'],
                        this.onChangeBranch,
                        this.props.data[this.branches_id].dataset[0] ?
                            this.props.data[this.branches_id].dataset.map((x) => {
                                // console.log('branchesList', x)
                                return (<Option value={x.code} valuefilter={x.code + " " + x.name + " " + x.address} disabled={x.bIsExcluded == '1'}>
                                    <span className={"text_item"} style={x.closeHour ? { color: '#aaaaaa' } : {}}>
                                        {x.name}<br />
                                        {x.address}
                                        {x.closeHour || x.isOpen !== '1' ? ' - ' : ''}
                                        {x.closeHour ? <u style={{ color: 'red' }}>{this.getText(14319) + " " + x.closeHour.slice(0, 5)}</u> : ''}
                                        {x.isOpen !== '1' ? <u style={{ color: 'red' }}> {this.getText(13562)}</u> : ''}
                                        {x.bIsExcluded == '1' ? <u style={{ color: 'red' }}> {this.getText(20925)}</u> : ''}
                                    </span>
                                </Option>)
                            }) : dmData && dmData.needAddress === '1' ?
                                (<Option value={'notAddress'}>
                                    <span className={"text_item"} style={{ color: 'red' }}> - {this.getText(13588)} - </span>
                                </Option>) : '',
                        oData.orderFields['dBranch'],
                        true
                    )
                    : (<Form.Item
                        required={RequiredFields.indexOf(field) > -1}
                        validateStatus={(RequiredFields.indexOf(field) > -1 && !oData.orderFields[field]) ? "error" : "success"}
                    >
                        <Input
                            className={"text_item"} style={{ height: 50 }}
                            type={field === 'dPhone' ? 'tel' : undefined}
                            value={oData.orderFields[field]}
                            readOnly={field === 'dPhone' && !this.props.isGuest && !(this.props.isFromPos && this.props.data[this.setting_id].pPOSDefaultCustomerId === oData.orderFields.cID)}
                            onChange={(v) => {
                                if (field == 'dName' && v.target.value && v.target.value.length > 45) message.error(this.getText(17646))
                                else this.props.setJson(this.id + ".orderFields", { [field]: v.target.value })
                            }} />
                    </Form.Item>)}
        </Col>)
    }

    addressStyle = () => {
        let changeAddress = (dCity, dStreet, dBuilding, dLat, dLng, dCountry) => {



            let valid = (this.props.notValidAddress && dLat && dLng) || (dCity && dStreet && dBuilding && dLat && dLng) ? true : false;
            let isFromPos = this.props.isFromPos;
            let isBlockBranchDelivery = this.props.data[this.setting_id].pBlockBranchWhenDelivery == '1';
            let dBranch = this.props.data[this.id].orderFields.dBranch;
            let dPosNumber = this.props.data[this.id].orderFields.dPosNumber;
            let dPriceList = this.props.data[this.id].orderFields.dPriceList;

            let aError = (e) => {
                this.setState({ addressError: e }, () => {
                    this.props.setJson(this.id + ".orderFields", {
                        dCity: '',
                        dStreet: '',
                        dBuilding: '',
                        dLat: '',
                        dLng: '',
                        dBranch,
                        dFullAddress: dStreet + " " + dBuilding + ", " + dCity
                    })

                })
            }

            if (valid) {
                this.props.sendAPI(
                    'check_branch_delivery_radius',
                    'dLat\fdLng\fdCountry\fdMethod\fdCityName\r' + dLat + '\f' + dLng + '\f' + dCountry + '\f' + this.props.modalData + "\f"
                    + (this.props.data[this.setting_id].pDeliveryCalcType == '1' ? dCity : ""),
                    (ob) => {
                        let data = ob.data ? ob.data.split("\r") : [];
                        let dataset = [];

                        let bOpen = false;
                        dBranch = null;
                        // let of = this.props.data[this.id].orderFields;
                        // if (of.dUserCheck) {
                        //     dBranch = of.dBranch;
                        //     dPosNumber = of.dPosNumber;
                        //     dPriceList = of.dPriceList;
                        // }

                        data.forEach((x, i) => {
                            let y = x.split("\f");

                            if ((y[5] === '1' && (this.props.data[this.setting_id].pDeliveryCalcType != '1' || y[19] == '1')) || this.props.isFromPos) {
                                bOpen = true;
                                if (!dBranch && y[21] != '1') {
                                    dBranch = y[0];
                                    dPosNumber = y[13];
                                    dPriceList = y[14];
                                }
                            }

                            dataset.push({
                                code: y[0],
                                name: y[1],
                                address: y[2],
                                radius: y[3],
                                ps: y[4],
                                isOpen: this.props.isFromPos ? '1' : y[5],
                                prepareTime: y[6],
                                betwenRadius: y[7],
                                dItem: y[8],
                                dItemName: y[9],
                                dPricePerKm: y[10],
                                dMaxPrice: y[11],
                                dIsRound: y[12],
                                posNumber: y[13],
                                priceList: y[14],
                                dMinPrice: y[15],
                                dPriceFirstKm: y[16],
                                bAcceptNow: y[17],
                                bAcceptHour: y[18],
                                bInAreas: y[19],
                                bPhones: y[20],
                                bIsExcluded: y[21]
                            });
                        });

                        let modalNotAreaFind = null;

                        if (this.props.data[this.setting_id].pDeliveryCalcType == '1') {
                            if (dataset[0]?.bInAreas != '1') {
                                const { name, bPhones } = dataset[0] ?? {}
                                modalNotAreaFind = { name, bPhones }
                            }

                            dataset = dataset.filter(f => f.bInAreas == '1')


                        }

                        let bIsExcluded = dataset[0]?.bIsExcluded == '1';

                        if (isFromPos || isBlockBranchDelivery) dataset = [dataset.find(f => f.code == dBranch)]


                        this.setState({ addressError: dataset[0] ? false : bIsExcluded ? 20926 : 13551, modalNotAreaFind }, () => {
                            this.props.setJson(this.branches_id, { dataset: dataset });
                            this.props.setJson(this.id + ".orderFields", {
                                dCity: dCity,
                                dStreet: dStreet,
                                dBuilding: dBuilding,
                                dLat: dLat,
                                dLng: dLng,
                                dBranch, dPosNumber, dPriceList,
                                dFullAddress: dStreet + " " + dBuilding + ", " + dCity
                            });

                            this.onChangeBranch(dBranch, this.props.modalData)

                        })
                    }, this.props.errorCallback);
            } else {
                aError(13372);
            }
        }

        let orderFields = this.props.data[this.id].orderFields;
        let custLocation = this.props.data.formData ? this.props.data.formData.custLocation : null;
        let isStyle4 = this.props.data[this.setting_id].pDesktopCategoriesView == '4'
        let isStyle5 = this.props.data[this.setting_id].pDesktopCategoriesView == '5'


        return (<Col span={this.mobile || isStyle4 || isStyle5 ? 24 : 15}>
            {this.labelStyle(this.getText(13371), true)}
            <Form.Item
                required={true}
                onBlur={() => {
                    this.setState({
                        addressError: !this.props.notValidAddress && (!orderFields.dCity || !orderFields.dStreet || !orderFields.dBuilding) ? 13372 : false
                    });
                }} >
                <GoogleAddress
                    placeholder={''}
                    inputStyle={{ paddingTop: 0, paddingBottom: 0, height: 50, marginRight: 10, borderRadius: 5 }}
                    changeAddress={changeAddress}
                    value={orderFields.dFullAddress}
                    latLng={custLocation ? { lat: custLocation.latitude, lng: custLocation.longitude } : null}
                    getLocationAgain={this.props.getLocationAgain}
                    getLocationAgainText={this.props.getLocationAgainText}
                    getText={this.getText}
                />
                {this.state.addressError ? (<div style={{ color: 'red' }}>{this.getText(this.state.addressError)}</div>) : ''}
                <Checkbox
                    checked={this.props.notValidAddress}
                    onChange={e => { this.props.onChangeValidAddress(e.target.checked) }}
                    className={"text_item"}>
                    {this.getText(19754)}
                </Checkbox>
            </Form.Item>
        </Col>)
    }

    dQtnFields = () => {
        let dqData = this.props.data[this.dQtn_id].data;
        let siteSettings = this.props.data[this.setting_id];
        let isStyle3 = siteSettings.pDesktopCategoriesView == '3';

        let iStyle = { margin: 5, width: '50%', height: 50 }
        let inputStyle = (text, index, required) => {
            return (<div>
                {this.labelStyle(text, required)}
                <span>
                    <Form.Item
                        required={required}
                        validateStatus={(required && !dqData[index].mValue) ? "error" : "success"}
                    >
                        <Input
                            className={"text_item"}
                            style={iStyle}
                            value={dqData[index].mValue}
                            onChange={(e) => {
                                let newData = [...dqData];
                                newData[index] = { ...dqData[index], mValue: e.target.value };
                                this.props.setJson(this.dQtn_id, { data: newData })
                            }} />
                    </Form.Item>
                </span>
            </div>)
        }

        let checkBoxStyle = (text, index, required) => {
            return (<div>
                <Checkbox
                    style={{ padding: 4, border: required && dqData[index].mValue != '1' ? '2px solid red' : 'none' }}
                    checked={dqData[index].mValue == '1'}
                    onChange={(e) => {
                        let newData = [...dqData];
                        newData[index] = { ...dqData[index], mValue: e.target.checked ? '1' : '0' };
                        this.props.setJson(this.dQtn_id, { data: newData })
                    }} >
                    <span className={"text_item"} style={{ marginRight: 10 }}>{text}</span>
                </Checkbox>
            </div>)
        }

        let selectStyle = (text, index, required) => {
            return (<div>
                {this.labelStyle(text, required)}
                {this.fieldSelectStyle(
                    "dQtn" + index,
                    dqData[index].mValue !== '' ? parseInt(dqData[index].mValue) : '',
                    (e) => {
                        let newData = [...dqData];
                        newData[index] = { ...dqData[index], mValue: e };
                        this.props.setJson(this.dQtn_id, { data: newData })
                    },
                    dqData[index].mOptions.map((x, i) => (<Option key={index} value={i}>{x}</Option>)),
                    !required || dqData[index].mValue !== '')}
            </div>)
        }

        return (<div style={isStyle3 ? { paddingRight: 50 } : {}}>
            {dqData.map((x, i) => {
                switch (x.mType) {
                    case 'Text': return inputStyle(x.mDesc, i, x.mIsMandatory == '1');
                    case 'Checkbox': return checkBoxStyle(x.mDesc, i, x.mIsMandatory == '1');
                    case 'Select': return selectStyle(x.mDesc, i, x.mIsMandatory == '1');
                    case 'Const': return (<div className="cotw_const_text_by_method_type">{x.mDesc}</div>)
                    default: return ''
                }
            })}
        </div>)
    }

    selectTypeStyle = (span) => {
        let delTypes = this.props.data[TableIDs.genericSelectorDeliveryMethods].dataset;
        let mData = this.props.modalData;
        let isStyle4 = this.props.data[this.setting_id].pDesktopCategoriesView == '4'
        let isStyle5 = this.props.data[this.setting_id].pDesktopCategoriesView == '5'

        return (<Col span={this.mobile || isStyle4 || isStyle5 ? 24 : span}>
            {this.labelStyle(this.getText(13113), true)}
            {this.fieldSelectStyle(
                'orderType',
                mData,
                b => { this.props.changeModal(b) },
                [
                    mData === '0' ? (<Option value={'0'}> - </Option>) : "",
                    delTypes.map((x) => (<Option value={x.code}>{x.name}</Option>))
                ],
                parseInt(mData)
            )}
        </Col>)
    }

    futureOrder = () => {
        let fo = this.props.data[this.id].futureOrder;
        let bSelect = this.props.data[this.branches_id].dataset.find(f => f && f.code == this.props.data[this.id].orderFields['dBranch']);
        let isOpen = bSelect ? bSelect.isOpen : null;
        let bAcceptNow = bSelect ? bSelect.bAcceptNow : '0';
        let bAcceptHour = bSelect ? bSelect.bAcceptHour : '0';
        let prepareTime = bSelect ? bSelect.prepareTime : null;
        if (this.props.data[this.setting_id].pDeliveryCalcType == 1) prepareTime = this.props.data[this.id].orderFields.dAreaMinutes
        let fTimes = this.props.data[this.times_id].dataset;
        let filterTime = this.props.data[this.times_id].hours;
        let mobile = window.innerWidth <= 700 ? true : false;

        let futureDate = this.props.data[this.id].orderFields['futureDate'];
        let futureTime = this.props.data[this.id].orderFields['futureTime'];

        let cbStyle = (type) => {
            let onClick = () => {
                if (type == 1) {
                    this.props.setJson(this.id, { futureOrder: false })
                    this.props.setJson(this.id + '.orderFields', { futureTime: '', futureDate: '' })
                } else {
                    this.props.setJson(this.id, { futureOrder: true })
                    this.setHoursSelect(fTimes[0]);
                }
            }
            return (type == 1 && !fo) || (type == 2 && fo) ?
                this.props.getClassNameStyle("extra_checkbox_checked", { margin: 10 }, '', onClick)
                // (<div className={"extra_checkbox_checked"} style={{ margin: 10 }} onClick={onClick}>&#10004;</div>)
                : (<div className={"extra_checkbox"} style={{ margin: 10 }} onClick={onClick} />)
        }

        let textStyle = (cb, content) => (<div className={"text_item"}>{cb}{content}</div>);

        let dateSelector = this.fieldSelectStyle(
            'dateSelector',
            futureDate,
            (e) => {
                let dateData = fTimes.find(f => f.date === e);
                this.setHoursSelect(dateData, bAcceptNow != '1' && bAcceptHour == '1');
            },
            fTimes.map((x) => (<Option dir={"rtl"} value={x.date}>{moment(x.date).format("DD/MM/YYYY")} - {this.getText(21130 + moment(x.date).day())}</Option>)),
            futureDate);

        let timeSelector = this.fieldSelectStyle(
            'timeSelector',
            futureTime,
            (e) => { this.props.setJson(this.id + '.orderFields', { futureTime: e }) },
            filterTime.map((x) => (<Option value={x}>{x.split(":").slice(0, 2).join(":")}</Option>)),
            futureTime);

        let isStyle4 = this.props.data[this.setting_id].pDesktopCategoriesView == '4'
        let isStyle5 = this.props.data[this.setting_id].pDesktopCategoriesView == '5'


        return bSelect ? (<Col span={24}>
            <Row>
                <Col span={mobile || isStyle4 || isStyle5 ? 24 : 8}>
                    {isOpen == 1 ? bAcceptNow == 1 ? textStyle(cbStyle(1), this.getText(13583)) : "" : textStyle('', this.getText(21810))}
                    {fTimes.length > 0 ? textStyle(cbStyle(2), this.getText(13582)) : textStyle('', this.getText(13587))}
                </Col>
                <Col span={mobile || isStyle4 || isStyle5 ? 24 : 8}>
                    {fo ? dateSelector : prepareTime ? textStyle('', this.getText(13584) + ' ' + this.minutesFormat(prepareTime)) : ""}
                </Col>
                <Col span={mobile || isStyle4 || isStyle5 ? 24 : 8}>{fo && bAcceptHour == '1' ? timeSelector : ''}</Col>
            </Row>
        </Col>) : "";
    }

    onChangeBranch = (bID, method) => {

        if ((bID !== "notAddress" && bID !== this.props.data[this.id].orderFields.dBranch) || method) {

            let branchData = this.props.data[this.branches_id].dataset.find(f => f?.code === bID);
            if (branchData) {
                let isOpen = branchData.isOpen === '1';
                let posNumber = branchData.posNumber;
                let newPriceList = branchData.priceList;
                let bAcceptNow = branchData.bAcceptNow;
                let bAcceptHour = branchData.bAcceptHour;

                this.props.sendAPI(this.api.get_times, 'bID\fmethodId\r' + bID + '\f' + this.props.modalData, (ob) => {
                    let data = ob.data ?
                        ob.data.split("\r").map((x) => {
                            const [date, from, to, isExc, excFrom, excTo] = x.split("\f");
                            let from1 = from
                            let to1 = to
                            let from2 = null
                            let to2 = null
                            if (isExc) {
                                if (excFrom <= from && excTo >= to) {
                                    return null;
                                } else if (excFrom <= from) {
                                    from1 = excTo
                                } else {
                                    to1 = excFrom
                                    if (excTo < to) {
                                        from2 = excTo
                                        to2 = to
                                    }
                                }
                            }
                            return { date, from1, to1, from2, to2 }
                        }).filter(f => f)
                        : [];

                    const { orderFields, futureOrder } = this.props.data[this.id]
                    let futureDatetime = null
                    if (data.length > 0 || isOpen) {

                        this.props.setJson(this.id, { futureOrder: !isOpen || futureOrder })
                        this.props.setJson(this.times_id, { dataset: data });

                        futureDatetime = data.find(f => {
                            const t = moment(orderFields.futureTime, "HH:mm:ss");
                            const from1 = moment(f.from1, "HH:mm:ss");
                            const to1 = moment(f.to1, "HH:mm:ss");
                            const from2 = moment(f.from2, "HH:mm:ss");
                            const to2 = moment(f.to2, "HH:mm:ss");
                            return f.date == orderFields.futureDate && (t.isBetween(from1, to1, undefined, "[]") || t.isBetween(from2, to2, undefined, "[]"))
                        })

                        let newData = {
                            dBranch: bID,
                            dPosNumber: posNumber,
                            dPriceList: newPriceList,
                            dUserCheck: true,
                            bAcceptNow,
                            bAcceptHour,
                            futureDate: (!isOpen || futureOrder) && futureDatetime ? orderFields.futureDate : "",
                            futureTime: (!isOpen || futureOrder) && futureDatetime ? orderFields.futureTime : "",
                        }

                        if (this.props.data[this.id].orderFields.dBranch != bID) {
                            newData = {
                                ...newData,
                                dAreaId: null,
                                dAreaName: null,
                                dAreaPrice: null,
                                dAreaMinimum: null,
                                dAreaMinutes: null,
                            }
                        }

                        this.props.setJson(this.id + ".orderFields", newData);


                        if (data[0] && !isOpen && bAcceptNow === '1') this.setHoursSelect(data[0]);


                    } else {
                        this.setState({ modalNotOpen: true });
                    }

                    if (bAcceptNow !== '1') {
                        this.props.setJson(this.id, { futureOrder: true })
                        this.props.setJson(this.id + '.orderFields', {
                            futureDate: futureDatetime ? orderFields.futureDate : "",
                            futureTime: futureDatetime ? orderFields.futureTime : "",
                        })
                    }
                }, this.props.errorCallback)


            }
        }
        this.setState({ changeBranch: null }, () => {
            this.props.apiSettings()
            this.props.apiMsgView()
        })
    }

    setHoursSelect = (dateToFilter, notUpdateTime) => {
        var filterTime = [];
        const hFormat = (hour, half) => (hour < 10 ? '0' + hour : hour) + ':' + (half ? '30' : '00') + ':00';
        const getFilterTime = (from, to) => {
            let fTime = from.split(':');
            let firstTime = { h: parseInt(fTime[0]), m: parseInt(fTime[1]), s: parseInt(fTime[2]) }
            let lTime = to.split(':');
            let lastTime = { h: parseInt(lTime[0]), m: parseInt(lTime[1]), s: parseInt(lTime[2]) }

            for (let h = firstTime.h; h <= lastTime.h; h++) {
                if (h === firstTime.h && (firstTime.m > 0 || firstTime.s > 0)) {
                    if (firstTime.m < 30 || (firstTime.m === 30 && firstTime.s === 0)) {
                        filterTime.push(hFormat(h, true));
                    }
                } else if (h === lastTime.h && (lastTime.m < 30 || (firstTime.m === 30 && firstTime.s === 0))) {
                    filterTime.push(hFormat(h, false));
                } else {
                    filterTime.push(hFormat(h, false));
                    filterTime.push(hFormat(h, true));
                }
            }
        }

        getFilterTime(dateToFilter.from1, dateToFilter.to1)
        if (dateToFilter.from2) getFilterTime(dateToFilter.from2, dateToFilter.to2)

        this.props.setJson(this.times_id, { hours: filterTime })
        this.props.setJson(this.id + '.orderFields', { futureTime: notUpdateTime ? "" : filterTime[0], futureDate: dateToFilter.date })
    }

    handelClose = () => {
        this.setState({
            addressError: false,
            modalNotOpen: false,
        }, () => {
            this.props.changeModal(false)
        });
    }

    handleOk = () => {
        let mData = this.props.modalData;
        let oData = this.props.data[this.id];
        let _phone = oData.orderFields.dPhone;
        let dqData = this.props.data[this.dQtn_id].data;
        let dMethods = this.props.data[TableIDs.genericSelectorDeliveryMethods].dataset;
        let dmData = dMethods.find(f => f.code === mData);
        let deliveryCost = null;
        let siteSettings = this.props.data[this.setting_id];
        let branchAndOrderTypeOnly = siteSettings.pStartPage == "OrderTypeRequiredOnly" && this.props.nextRegi != 2 && this.props.nextRegi != 3
        let notBranchAndOrderType = siteSettings.pStartPage == "OrderTypeRequiredOnly" && (this.props.nextRegi == 2 || this.props.nextRegi == 3)


        let RequiredFields = branchAndOrderTypeOnly ? ['dBranch'] : notBranchAndOrderType ? ['dName', 'dPhone'] : ['dName', 'dPhone', 'dBranch'];
        if (dmData && dmData.needAddress === '1' && !notBranchAndOrderType) {
            RequiredFields = [...RequiredFields, 'dLat', 'dLng'];
            if (siteSettings.pDeliveryCalcType == 1) {
                RequiredFields = [...RequiredFields, 'dAreaId'];
            }
            if (!this.props.notValidAddress) {
                RequiredFields = [...RequiredFields, 'dCity', 'dStreet', 'dBuilding'];
            }
        }


        if ((oData.orderFields.bAcceptNow == 0 || oData.orderFields.bAcceptNow == '') && !notBranchAndOrderType) {
            RequiredFields = [...RequiredFields, 'futureDate']
            if (oData.orderFields.bAcceptHour == '1') RequiredFields = [...RequiredFields, 'futureTime']
        }

        let req = RequiredFields.find(f => !oData.orderFields[f]);
        let reqQtn = !branchAndOrderTypeOnly && dqData.find(f => f.mIsMandatory == '1' && (!f.mValue || (f.mType == 'Checkbox' && f.mValue == '0')));
        if (req || reqQtn || mData === '0' || this.state.addressError) {
            message.error(this.getText(13100));
        } else if (!branchAndOrderTypeOnly && !this.props.mobileValidate(_phone)) {
            message.error(this.getText(13528));
        } else {
            let nextRegi = this.props.nextRegi;
            let isGuest = this.props.isGuest;
            let guestTag = this.props.data[this.setting_id].pGuestTag;
            let needAddress = dmData ? dmData.needAddress : 0;
            let futureOrder = this.props.data[this.id].futureOrder;

            switch (nextRegi) {
                case 2:
                    if (!guestTag && isGuest) {
                        this.props.regiModal(false);
                    } else {
                        this.props.changeScreen(2)
                    }
                    break;
                case 3:
                    this.props.changeScreen(nextRegi)
                    break;
                default:
                    this.props.changeScreen(1)
            }

            if (needAddress === '1') {
                deliveryCost = this.calculationShippingFees(oData.orderFields['dBranch']);
            }

            this.props.setJson(this.id, { orderType: mData, needAddress, futureOrder, deliveryCost });
            this.handelClose();
        }
    }

    calculationShippingFees = (bID) => {
        let bData = this.props.data[this.branches_id].dataset.find(f => f.code === bID);

        if (this.props.data[this.setting_id].pDeliveryCalcType == '1') {
            return {
                dItem: bData.dItem,
                dItemName: bData.dItemName,
                dPrice: this.props.data[this.id].orderFields.dAreaPrice
            }
        } else {
            let betwenRadius = bData && bData.betwenRadius ? parseFloat(bData.betwenRadius) : 0;
            let dPricePerKm = bData && bData.dPricePerKm ? parseFloat(bData.dPricePerKm) : 0;
            let dPriceFirstKm = bData && bData.dPriceFirstKm ? parseFloat(bData.dPriceFirstKm) : dPricePerKm;
            let dMaxPrice = bData && bData.dMaxPrice ? parseFloat(bData.dMaxPrice) : 9999;
            let dMinPrice = bData && bData.dMinPrice ? parseFloat(bData.dMinPrice) : 0;

            let betwenRadiusFirst = betwenRadius > 1 ? 1 : betwenRadius;
            let betwenRadiusOther = betwenRadius > 1 ? betwenRadius - 1 : 0;

            let pSum = dPriceFirstKm * (bData.dIsRound == '1' ? Math.ceil(betwenRadiusFirst) : betwenRadiusFirst);
            if (betwenRadiusOther) {
                pSum += dPricePerKm * (bData.dIsRound == '1' ? Math.ceil(betwenRadiusOther) : betwenRadiusOther);
            }

            return {
                dItem: bData.dItem,
                dItemName: bData.dItemName,
                dPrice: (pSum < dMinPrice) ? dMinPrice : (pSum > dMaxPrice) ? dMaxPrice : pSum
            };
        }
    }

    onChangeArea = (record) => {

        this.setState({ modalAreas: false }, () => {

            this.props.setJson(this.id + ".orderFields", {
                dAreaId: record._ID,
                dAreaName: record._Name,
                dAreaPrice: record._Price,
                dAreaMinimum: record._Minimum,
                dAreaMinutes: record._Minutes,
            })
        })
    }

    minutesFormat = (v) => {
        let sum = v ? parseInt(v) : 0
        let d = sum >= 1440 ? Math.floor(sum / 1440) : 0
        let h = sum >= 60 ? Math.floor((sum - (d * 1440)) / 60) : 0
        let m = sum > 0 ? sum - (d * 1440) - (h * 60) : 0
        let res = "";
        if (d) res += `${d} ${this.getText(20919)}`
        if (h) res += `${res ? ` ${this.getText(20922)} ` : ''}${h} ${this.getText(20920)}`
        if (m) res += `${res ? ` ${this.getText(20922)} ` : ''}${m} ${this.getText(20921)}`

        return res
    }

    render() {
        let mData = this.props.modalData;
        let dMethods = this.props.data[TableIDs.genericSelectorDeliveryMethods].dataset;
        let dmData = dMethods.find(f => f.code === mData);
        let siteSettings = this.props.data[this.setting_id];
        let isStyle3 = siteSettings.pDesktopCategoriesView == '3';
        let isStyle4 = siteSettings.pDesktopCategoriesView == '4';
        let isStyle5 = siteSettings.pDesktopCategoriesView == '5';
        let isStyle6 = siteSettings.pDesktopCategoriesView == '6';
        let isOrderTypeRequired = siteSettings.pStartPage == "OrderTypeRequired" || siteSettings.pStartPage == "OrderTypeRequiredOnly"
        let branchAndOrderTypeOnly = siteSettings.pStartPage == "OrderTypeRequiredOnly" && this.props.nextRegi != 2 && this.props.nextRegi != 3
        let notBranchAndOrderType = siteSettings.pStartPage == "OrderTypeRequiredOnly" && (this.props.nextRegi == 2 || this.props.nextRegi == 3)
        let modalTitle = this.getText(13090)
        if (isOrderTypeRequired) modalTitle += " - " + (dmData?.name)

        let buttonsStyle = {
            margin: 10,
            width: 140,
            height: 50,
            background: isStyle3 ? "#88c23f" : isStyle4 || isStyle5 ? "#BE1E2D" : isStyle6 ? "#ddc268" : siteSettings.rPrimaryButtons,
        }

        let hClose = () => { this.setState({ modalNotOpen: false }) }

        let nAddress = dmData?.needAddress === '1' ? true : false;

        let className = "";
        if (isStyle3) className = "padding_0";
        if (isStyle4) className = "padding_0 modal_style_4";
        if (isStyle5) className = "padding_0 modal_style_5";

        const { dBranch } = this.props.data[this.id].orderFields

        if (nAddress && this.props.data[this.setting_id].pDeliveryCalcType == '1') {
            modalTitle = (<>
                {modalTitle}
                <Tooltip title={this.getText(21776) + (dBranch ? " " + this.getText(21777) : "")}>
                    <Button className={"btn"} style={{ float: "left", marginLeft: 40 }} onClick={() => { this.setState({ modalMultiPolygons: true }) }}>
                        <Icon style={{ fontSize: 16 }} type="table" theme="outlined" />
                    </Button>
                </Tooltip>
            </>)
        }


        return (<Modal
            className={className}
            visible={mData}
            width={this.mobile ? "95%" : isStyle4 || isStyle5 ? 500 : "60%"}
            title={isStyle4 || isStyle5 ? false : this.props.getClassNameStyle("title_block", {}, modalTitle)}
            onCancel={this.handelClose}
            footer={isStyle4 || isStyle5 ? false : [
                <Button className="cotw_button" style={{ ...buttonsStyle, background: isStyle3 ? "red" : siteSettings.rSecondaryButtons }} onClick={this.handelClose}>
                    <span className={"text_item cotw_button_text"} style={{ color: isStyle3 ? "white" : siteSettings.rFonts }}>{this.getText(13101)}</span>
                </Button>,
                <Button className="cotw_button" style={buttonsStyle} onClick={this.handleOk}>
                    <span className={"text_item cotw_button_text"} style={{ color: isStyle3 ? "white" : siteSettings.rFonts }}>{this.getText(13089)}</span>
                </Button>
            ]}
            ui={this.props.ui} uiActions={this.props.uiActions}
            data={this.props.data} dataAction={this.props.dataAction}>
            {isStyle4 ? <img src={modal_logo} style={{ width: "100%" }} /> : isStyle5 ? <div style={{ height: 50 }}></div> : ""}
            <div style={this.props.isFromPos ?
                { height: window.innerHeight - 250, overflow: 'scroll' }
                : isStyle4 || isStyle5 ? { padding: 20, marginTop: 50, background: "white" }
                    : {}}>

                <Row style={isStyle3 ? { padding: 20, paddingRight: 50 } : {}}>
                    {isOrderTypeRequired ? "" : this.selectTypeStyle(24)}
                    {((isStyle4 || isStyle5 || branchAndOrderTypeOnly) && !this.props.isLogin) ?
                        <div
                            style={{
                                width: 40,
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                this.props.regiModal(false)
                            }}>
                            <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.22 29.22"><g id="icon_connect"><g style={{ fill: '#000000' }}><path class="cls-1" d="m14.61,0C6.55,0,0,6.55,0,14.61s6.55,14.61,14.61,14.61,14.61-6.55,14.61-14.61S22.66,0,14.61,0Zm0,1.22c7.38,0,13.39,6.01,13.39,13.39,0,2.19-.54,4.24-1.47,6.07-7.15-4.19-13.44-3.97-17.47-3.03-3.22.75-5.51,2.03-6.54,2.69-.83-1.74-1.3-3.68-1.3-5.73C1.22,7.23,7.23,1.22,14.61,1.22Zm0,26.78c-4.9,0-9.18-2.65-11.51-6.58.91-.59,3.15-1.87,6.3-2.6,5.53-1.27,11.09-.28,16.53,2.91-2.37,3.76-6.55,6.27-11.32,6.27Z" /><path class="cls-1" d="m14.4,15.43c3.38,0,6.12-2.75,6.12-6.12s-2.75-6.12-6.12-6.12-6.12,2.75-6.12,6.12,2.75,6.12,6.12,6.12Zm0-11.03c2.71,0,4.91,2.2,4.91,4.91s-2.2,4.91-4.91,4.91-4.91-2.2-4.91-4.91,2.2-4.91,4.91-4.91Z" /></g></g></svg>
                            <div style={{ fontSize: 12, textAlign: "center" }}>{this.getText(13050)}</div>
                        </div>
                        : ""}
                    {(isStyle3 || isStyle4 || isStyle5) && !branchAndOrderTypeOnly ? this.fieldStyle(13091, 'dName', 12) : ""}
                    {(isStyle3 || isStyle4 || isStyle5) && !branchAndOrderTypeOnly ? this.fieldStyle(13092, 'dPhone', 12) : ""}
                    {nAddress && !notBranchAndOrderType ? this.addressStyle() : ''}
                    {nAddress && !notBranchAndOrderType ? this.fieldStyle(13096, 'dEntrance', 3) : ''}
                    {nAddress && !notBranchAndOrderType ? this.fieldStyle(13097, 'dFloor', 3) : ''}
                    {nAddress && !notBranchAndOrderType ? this.fieldStyle(13098, 'dApartement', 3) : ''}
                    {isStyle3 || isStyle4 || isStyle5 || branchAndOrderTypeOnly ? "" : this.fieldStyle(13091, 'dName', 12)}
                    {isStyle3 || isStyle4 || isStyle5 || branchAndOrderTypeOnly ? "" : this.fieldStyle(13092, 'dPhone', 12)}
                    {(this.props.isFromPos && siteSettings.pBranchSelectInPos != '1') || notBranchAndOrderType ? '' : [
                        this.fieldStyle(13549, 'dBranch', nAddress && this.props.data[this.setting_id].pDeliveryCalcType == '1' ? 12 : 24),
                        nAddress && this.props.data[this.setting_id].pDeliveryCalcType == '1' ? this.fieldStyle(19758, 'dAreaId', 12) : "",
                    ]}
                    {notBranchAndOrderType ? '' : this.futureOrder()}
                    {notBranchAndOrderType ? '' : this.fieldStyle(13099, 'dRemarks', 24)}
                </Row>
                {branchAndOrderTypeOnly ? "" : this.dQtnFields()}
                {isStyle4 || isStyle5 ?
                    <div className={"cotw_button"}
                        style={{ background: isStyle6 ? "#ddc268" : "#BE1E2D", color: isStyle6 ? "black" : "white", cursor: "pointer", textAlign: "center", fontSize: 22, padding: 8 }}
                        onClick={this.handleOk}>
                        <span className="cotw_button_text">{this.getText(18680)}</span>
                    </div>
                    : ""}
            </div>
            <Modal
                title={this.props.getClassNameStyle("title_block")}
                visible={this.state.modalNotOpen} onCancel={hClose} destroyOnClose={true} width={300}
                footer={[
                    <Button style={buttonsStyle} onClick={hClose}>
                        <span className={"text_item"} style={{ color: isStyle4 ? "white" : siteSettings.rFonts }}>{this.getText(13586)}</span>
                    </Button>
                ]}
                ui={this.props.ui} uiActions={this.props.uiActions}
                data={this.props.data} dataAction={this.props.dataAction}>
                <div className={"text_item"}>
                    <h2 style={{ textAlign: 'center' }}>{this.getText(13550)}</h2>
                </div>
            </Modal>
            <Modal
                title={this.props.getClassNameStyle("title_block")}
                visible={this.state.modalNotAreaFind != null}
                onCancel={() => { this.setState({ modalNotAreaFind: null }) }}
                destroyOnClose={true} width={300}
                footer={[
                    <Button style={buttonsStyle} onClick={() => { this.setState({ modalNotAreaFind: null }) }}>
                        <span className={"text_item"} style={{ color: isStyle4 ? "white" : siteSettings.rFonts }}>{this.getText(13586)}</span>
                    </Button>
                ]}
                ui={this.props.ui} uiActions={this.props.uiActions}
                data={this.props.data} dataAction={this.props.dataAction}>
                <div className={"text_item"} style={{ textAlign: 'center' }}>
                    <h2>{this.getText(19974)}</h2>
                    <h2>{this.getText(19975)}</h2>
                    <h2>{this.state.modalNotAreaFind?.name} {this.state.modalNotAreaFind?.bPhones}</h2>
                </div>
            </Modal>
            <Modal
                title={this.props.getClassNameStyle("title_block")}
                visible={this.state.modalAreas} onCancel={() => { this.setState({ modalAreas: false }) }} width={800}
                footer={false}>
                <ResponsiveTable
                    tableOnly
                    dataSource={this.props.data[this.areas_id].dataset}
                    columns={[
                        { title: this.getText(19738), dataIndex: "_Name", key: "_Name", width: '30%', render: t => t },
                        { title: this.getText(19739), dataIndex: "_Price", key: "_Price", width: '20%', render: t => t },
                        { title: this.getText(19740), dataIndex: "_Minimum", key: "_Minimum", width: '20%', render: t => t },
                        { title: this.getText(19741), dataIndex: "_Minutes", key: "_Minutes", width: '20%', render: this.minutesFormat },
                        { title: "", width: '10%', render: (t, r) => (<Button type="primary" onClick={() => { this.onChangeArea(r) }}>{this.getText(19759)}</Button>) },
                    ]}
                    pagination={false}
                    scroll={{ y: window.innerHeight - 200 }}
                />
            </Modal>
            <GenericModal
                visible={this.state.modalMultiPolygons}
                onCancel={() => { this.setState({ modalMultiPolygons: false }) }}
                title={this.getText(21776) + (dBranch ? " " + this.getText(21777) : "")}>
                <MultiPolygonMap
                    polygons={this.props.data[this.areasAll_id].dataset.filter(f => !dBranch || f.branch == dBranch)}
                    fitBounds={[
                        [29.492, 34.268], // Southwest
                        [33.332, 35.896]  // Northeast
                    ]}
                    defLat={31.4} defLng={34.9}
                />
            </GenericModal>
        </Modal>)

    }
}

export default DeliveryTypeFields;